<!--<div class="card card-w-title">-->
<div class="range-form">
  <div class="d-flex flex-wrap gap-10">
    <div class="d-flex flex-wrap flex-grow-1 gap-10">
      <div class="flex-shrink-1 pt-2">
        <span style="margin-right: 5px">Date From:</span>
        <span style="margin-right: 5px">
          <p-calendar
            [disabled]="isLoading"
            [(ngModel)]="kpiStartDate"
            [showTime]="false"
            name="kpiStartDate"
            view="month"
            dateFormat="MM yy"
            (ngModelChange)="onDateMonthChanged($event)"
            [minDate]="minKPIDate"
          ></p-calendar>
        </span>
      </div>
      <div class="d-flex flex-wrap flex-grow-1">
        <div class="flex-shrink-1 pt-2">
          <span style="margin-right: 5px">Range:</span>
        </div>
        <div class="flex-shrink-1 pt-2">
          <p-dropdown
            [disabled]="isLoading"
            [options]="monthRanges"
            [(ngModel)]="selectedMonthRange"
            placeholder="Select a month range"
            [style]="{ display: 'inline-block' }"
            tabindex="1"
            (onChange)="onDateRangeChanged($event)"
          >
          </p-dropdown>
        </div>
      </div>
    </div>

    <div class="flex-shrink-1 d-flex flex-wrap gap-10">
      <div class="flex-grow-1 pt-2">
        <span style="font-weight: bold">
          Export Start Date:
          <p-calendar
            [(ngModel)]="csvStartDate"
            [showTime]="false"
            name="csvStartDate"
            dateFormat="D d MM yy"
            [minDate]="minCSVDate"
          ></p-calendar>
        </span>
      </div>

      <div class="flex-shrink-1 pt-2">
        <span style="font-weight: bold">
          Export End Date:
          <p-calendar
            [(ngModel)]="csvEndDate"
            [showTime]="false"
            name="csvEndDate"
            dateFormat="D d MM yy"
            [minDate]="minCSVDate"
          ></p-calendar>
        </span>
      </div>
      <div class="flex-shrink-1">
        <button
          type="button"
          pButton
          (click)="exportCSV()"
          [disabled]="csvDownloading"
          pTooltip="Download all metrics to CSV file"
          tooltipPosition="left"
        >
          <span class="chart-loading button-text" *ngIf="csvDownloading"
            ><i class="fa fa-spinner fa-spin"></i>&nbsp; Downloading CSV...</span
          >
          <span *ngIf="!csvDownloading" class="button-text">
            <i class="fa fa-cloud-download"></i> Export To CSV</span
          >
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!monthlyTotals" class="loading-box">
  <i class="fa fa-spinner fa-spin"></i>&nbsp; Loading KPIs
</div>

<div *ngIf="monthlyTotals">
  <div *ngFor="let monthlyMetric of monthlyMetrics; let mi = index">
    <div class="metric-group">
      <div>
        <span class="metric-group-name">{{ monthlyMetric.groupName }}</span> &nbsp;
        <span class="metric-date-range">
          {{ currentStartDate | datex : 'ddd DD MMM YYYY' }} -
          {{ currentEndDate | datex : 'ddd DD MMM YYYY' }}
        </span>
      </div>
      <div class="last-updated">
        <span class="label">Last Updated:</span>
        <span *ngIf="lastRefreshTime">
          {{ lastRefreshTime | date : 'dd MMM yyyy HH:mm' }}
        </span>
        <span class="time-not-available" *ngIf="!lastRefreshTime"> Unknown </span>
      </div>
    </div>

    <div class="ui-g">
      <div
        [ngClass]="{
          'ui-g-12 ui-lg-6': monthlyMetric.metrics.length > 1,
          'ui-g-12': monthlyMetric.metrics.length == 1
        }"
        *ngFor="let metric of monthlyMetric.metrics"
      >
        <div
          class="chart-container"
          pTooltip="{{ metric.tooltip }}"
          tooltipPosition="top"
          tooltipStyleClass="ytooltip"
        >
          <p-header>
            <div
              style="
                text-align: center;
                font-size: 16px;
                font-weight: 500;
                padding-top: 5px;
                padding-bottom: 4px;
              "
            >
              {{ metric.title }}
              <span class="chart-loading" *ngIf="isLoading && !metric.liveFeed"
                ><i class="fa fa-spinner fa-spin"></i>&nbsp; Loading...</span
              >

              <span *ngIf="!isLoading">
                <span *ngIf="metric.chartData && metric.chartData.targetTotal > 0">
                  Target to date: {{ metric.chartData.targetTotal | number }} -
                </span>
                <span *ngIf="metric.chartData && metric.chartData.total > 0"
                  >Total: {{ metric.chartData.total | number }}</span
                >
                <span *ngIf="metric.chartData && metric.chartData.totalCurrency > 0"
                  >Total: {{ metric.chartData.totalCurrency | currency : 'GBP' }}</span
                >
                <span *ngIf="metric.chartData && metric.chartData.overallPercentage">
                  ({{ metric.chartData.overallPercentage }} )</span
                >
              </span>
              <span *ngIf="metric.liveFeed">
                <span class="chart-loading" *ngIf="isLoadingLiveFeed"
                  ><i class="fa fa-spinner fa-spin"></i>&nbsp; Loading...</span
                >
                <div>
                  <p-dropdown
                    name="liveFeedOptions"
                    [options]="liveFeedOptions"
                    [(ngModel)]="selectedLiveFeed"
                    styleClass="filterItem"
                    [style]="{ width: '50%' }"
                    (onChange)="liveFeedOptionChanged($event)"
                  ></p-dropdown>
                  <p-dropdown
                    *ngIf="selectedLiveFeed == liveFeedOptionEnum.Daily"
                    name="liveFeedOptions"
                    [options]="dailyLiveFeedOptions"
                    [(ngModel)]="selectedDailyLiveFeedOption"
                    styleClass="filterItem"
                    [style]="{ width: '50%' }"
                    (onChange)="dailyLiveFeedOptionChanged($event)"
                  ></p-dropdown>
                  <p-dropdown
                    *ngIf="selectedLiveFeed == liveFeedOptionEnum.Weekly"
                    name="liveFeedOptions"
                    [options]="weeklyLiveFeedOptions"
                    [(ngModel)]="selectedWeeklyLiveFeedOption"
                    styleClass="filterItem"
                    [style]="{ width: '50%' }"
                    (onChange)="weeklyLiveFeedOptionChanged($event)"
                  ></p-dropdown>
                </div>
              </span>
            </div>
          </p-header>

          <p-chart
            [type]="metric.chartData.chartType"
            [options]="metric.chartData.options"
            [plugins]="this.plugin"
            [height]="metric?.data?.length > 0 ? 300 : 455"
            (onDataSelect)="selectedChartData(monthlyMetric, metric, $event)"
            [data]="metric.chartData"
          ></p-chart>

          <p-footer>
            <!-- display first metric as current -->
            <div class="stats-wrapper" *ngIf="metric?.data?.length > 0">
              <div class="ui-g">
                <div class="ui-g-3">
                  <div class="monthly-metric">
                    <div class="metric-headline-date">{{ metric.data[0].date }}</div>

                    <div class="metric-center">
                      <div *ngIf="metric.showPercentageAsHeadline" class="current-value">
                        <span>{{
                          (metric.useValueAsPercent
                            ? metric.data[0].value
                            : metric.data[0].percOfComplete
                          ) | number
                        }}</span>
                        <span *ngIf="!metric.noPercSymbol">%</span>
                      </div>
                      <div
                        *ngIf="
                          !metric.showPercentageAsHeadline &&
                          metric.displayStyle == MetricDisplayStyle.Number
                        "
                        class="current-value"
                      >
                        {{ metric.data[0].value | number }}
                      </div>
                      <div
                        *ngIf="metric.displayStyle == MetricDisplayStyle.Currency"
                        class="current-value"
                      >
                        {{ getCurrencySummaryValue(metric.data[0].value) }}
                      </div>
                      <div class="metric-title">{{ metric.title }}</div>
                      <div class="current-change">{{ metric.data[0].percentageLabel }}</div>
                    </div>

                    <!-- Target moves per working day -->
                    <!--                                            <div *ngIf="metric.data[0].extraMetrics" class="extra-metric-container">-->
                    <!--                                                <div class="extra-metric">Target/Wrk. Day: {{metric.data[0].extraMetrics[0]}}</div>-->
                    <!--                                                <div class="extra-metric">Moves/Wrk. Day: {{metric.data[0].extraMetrics[1]}}</div>-->
                    <!--                                                <div class="extra-metric">-->
                    <!--                                                    Daily vs Target:-->
                    <!--                                                    <span [ngClass]="{'percentage-green':metric.data[0].extraMetrics[2] > 0, 'percentage-red':metric.data[0].extraMetrics[2] < 0}">-->
                    <!--                                                        {{metric.data[0].extraMetrics[2]}}%-->
                    <!--                                                    </span>-->
                    <!--                                                </div>-->
                    <!--                                            </div>-->
                  </div>
                </div>
                <div class="ui-g-9" style="overflow-x: auto">
                  <table class="monthly-metric metric-table table-striped">
                    <thead>
                      <tr>
                        <th>&nbsp;</th>
                        <th class="metric-number">
                          <span *ngIf="metric.totalName">{{ metric.totalName }}</span>
                        </th>
                        <th class="metric-number" *ngIf="!metric.noComp">Comp.</th>
                        <th class="metric-number" *ngIf="!metric.noComp && !metric.noCompPerc">
                          % {{ metric.totalName }}
                        </th>
                        <th class="metric-number">
                          +/- Prev. <span *ngIf="metric.percAgainstComplete">Comp.</span>
                        </th>
                        <th class="metric-number" *ngIf="metric.showTarget">Target</th>
                        <th class="metric-number" *ngIf="metric.showTarget">% Target</th>
                        <th class="metric-number" *ngIf="metric.data[0]?.extraMetrics">
                          Daily Target
                        </th>
                        <th class="metric-number" *ngIf="metric.data[0]?.extraMetrics">
                          Daily Mvmts
                        </th>
                        <th class="metric-number" *ngIf="metric.data[0]?.extraMetrics">
                          Daily Target %
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let data of metric.data; let i = index">
                        <td>{{ data.date }}</td>
                        <td
                          class="metric-number"
                          *ngIf="metric.displayStyle == MetricDisplayStyle.Number"
                        >
                          {{ data.value | number }}
                        </td>
                        <td
                          class="metric-number"
                          *ngIf="metric.displayStyle == MetricDisplayStyle.Currency"
                        >
                          {{ getCurrencyValue(data.value) }}
                        </td>
                        <td
                          class="metric-number"
                          *ngIf="metric.displayStyle == MetricDisplayStyle.Percentage"
                        >
                          {{ data.value }}%
                        </td>
                        <td class="metric-number" *ngIf="!metric.noComp">
                          {{ data.completed | number }}
                        </td>
                        <td class="metric-number" *ngIf="!metric.noComp && !metric.noCompPerc">
                          {{ data.percOfComplete }}
                          %
                        </td>
                        <td
                          class="metric-number"
                          [ngClass]="{
                            'percentage-green': data.percDiff > 0,
                            'percentage-red': data.percDiff < 0
                          }"
                        >
                          {{ data.percentLabel }}
                        </td>
                        <td class="metric-number" *ngIf="metric.showTarget">
                          {{ data.target | number }}
                        </td>
                        <td class="metric-number" *ngIf="metric.showTarget">
                          {{ data.targetPercentLabel }}
                        </td>
                        <td class="metric-number" *ngIf="data.extraMetrics">
                          {{ data.extraMetrics[0] }}
                        </td>
                        <td class="metric-number" *ngIf="data.extraMetrics">
                          {{ data.extraMetrics[1] }}
                        </td>
                        <td
                          [ngClass]="{
                            'percentage-green': data.extraMetrics[2] > 0,
                            'percentage-red': data.extraMetrics[2] < 0
                          }"
                          class="metric-number"
                          *ngIf="data.extraMetrics"
                        >
                          {{ data.extraMetrics[2]?.toFixed(0) }} %
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </p-footer>
        </div>
      </div>
    </div>
  </div>
</div>

<!--</div>-->
